import IArborProviderConfig from "./ArborProviderConfig";

export function canonicalizeArborProviderConfig(configuration: IArborProviderConfig): IArborProviderConfig {
    return {
        ...configuration,
        ApiCredentials: {
            EstablishmentUrl: configuration.ApiCredentials?.EstablishmentUrl ?? ""
        }
    };
}